<div class="container">
    <h1>Bulk Clone</h1>
    <span class="messages">
        <img src="/wp-content/themes/swarm/app/assets/images/loading.gif" *ngIf="loading" class="loader">
    </span>
    <form class="form">
        <textarea matInput [(ngModel)]="value"></textarea>
        <button mat-raised-button color="primary" (click)="clone()">Submit</button>
    </form>
    <div class="results" *ngFor="let result of results">
        <p *ngIf="![].constructor.isArray(result)">{{result}}</p>
        <p *ngIf="[].constructor.isArray(result)"><b>{{result[0]}}, {{result[1]}}:</b> {{result[2]}} <i>(Code: {{result[3]}})</i></p>
    </div>
</div>